import { jsx as _jsx } from "react/jsx-runtime";
import { useReducer } from 'react';
function withStore(props) {
    const { StateContext, initialState, DispatchContext, reducer } = props;
    const [state, dispatch] = useReducer(reducer, initialState);
    return (_jsx(StateContext.Provider, { value: state, children: _jsx(DispatchContext.Provider, { value: dispatch, children: props.children }) }));
}
export default withStore;
